import { Component, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterviewDataService } from './services/interview-data.service'


@Component({
    selector: 'delete-interview',
    template: `
    <div class="modal-header">
      <h4 class="modal-title">{{'interviews.Delete Interview' | translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>{{'interviews.Confirm Delete' | translate}}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn_secondary" (click)="activeModal.close('Close click')">{{'interviews.Close' | translate}}</button>
        <button (click)="deleteInterview();" class="btn btn_danger">{{'interviews.Delete' | translate}}</button>
    </div>
  `,
    standalone: false
})
export class DeleteInterviewComponent {

    @Output() deleteAttempt: EventEmitter<any> = new EventEmitter<any>();

    constructor(public activeModal: NgbActiveModal,
                private _dataService: InterviewDataService) {}

    deleteInterview() {

        let confirmDelete = confirm('Are you ABSOLUTELY SURE you want to do this?');
        if (!confirmDelete) {
            return;
        }
        this.deleteAttempt.emit(this._dataService.attemptId);
    }
}

